import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { DownloadCartModule } from './download-cart/download-cart.module';
import { CartComponent } from './cart.component';
import { MainContentDrawerModule } from './main-content-drawer/main-content-drawer.module';
import { BulkGtinSearchModule } from '../content/bulk-search/bulk-search.module';

@NgModule({
    imports: [CommonModule, RouterModule, DownloadCartModule, MainContentDrawerModule, BulkGtinSearchModule],
    declarations: [CartComponent],
    exports: [CartComponent]
})
export class CartModule {}
